import * as tslib_1 from "tslib";
import { OnInit, OnDestroy, ElementRef, DoCheck } from '@angular/core';
import { FormBuilder, Validators, NgControl, NgForm, FormGroupDirective } from '@angular/forms';
import { MatFormFieldControl, ErrorStateMatcher } from '@angular/material';
import { FocusMonitor } from '@angular/cdk/a11y';
import { Subject } from 'rxjs';
import { untilDestroyed } from 'ngx-take-until-destroy';
import { getErrors } from '@awp/forms';
import { isNullOrEmpty, coerceBooleanProperty } from '@awp/core/utils';
import { _AwpComponentMixinBase } from '../custom-base.component';
var ExpiryDate = /** @class */ (function () {
    function ExpiryDate(month, year) {
        this.month = month;
        this.year = year;
    }
    return ExpiryDate;
}());
export { ExpiryDate };
var ExpiryDateInputComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ExpiryDateInputComponent, _super);
    function ExpiryDateInputComponent(ngControl, _parentForm, _parentFormGroup, _defaultErrorStateMatcher, formBuilder, focusMonitor, elRef) {
        var _this = _super.call(this, _defaultErrorStateMatcher, _parentForm, _parentFormGroup, ngControl) || this;
        _this.formBuilder = formBuilder;
        _this.focusMonitor = focusMonitor;
        _this.elRef = elRef;
        _this.id = "ap-expiry-date-input-" + ExpiryDateInputComponent.nextId++;
        _this.describedBy = '';
        _this.controlType = 'ap-expiry-date-input';
        _this.stateChanges = new Subject();
        _this.focused = false;
        _this._required = false;
        _this._disabled = false;
        _this._value = null;
        _this._onTouched = function () { };
        _this._onChange = function (value) { };
        if (_this.ngControl != null) {
            _this.ngControl.valueAccessor = _this;
        }
        _this.focusMonitor
            .monitor(elRef.nativeElement, true)
            .pipe(untilDestroyed(_this))
            .subscribe(function (origin) {
            _this.focused = !!origin;
            _this.stateChanges.next();
        });
        _this.form = _this.formBuilder.group({
            month: [null, [Validators.required, Validators.pattern(/[0-9]{1,2}/)]],
            year: [null, [Validators.required, Validators.pattern(/[0-9]{1,2}/)]],
        }, {
            updateOn: 'blur'
        });
        return _this;
    }
    ExpiryDateInputComponent.prototype.ngOnInit = function () {
        var _this = this;
        // pad to 2 digits
        this.form.get('month')
            .valueChanges
            .pipe(untilDestroyed(this))
            .subscribe(function (value) {
            if (value && value.length === 1) {
                _this.form.get('month').setValue(value.padStart(2, '0'));
            }
        });
        this.form.valueChanges
            .pipe(untilDestroyed(this))
            .subscribe(function (p) {
            _this.notifyChanged(p);
        });
    };
    ExpiryDateInputComponent.prototype.ngOnDestroy = function () {
        this.stateChanges.complete();
        this.focusMonitor.stopMonitoring(this.elRef.nativeElement);
    };
    ExpiryDateInputComponent.prototype.ngDoCheck = function () {
        if (this._onTouched != null) {
            // if you tab past all date controls, then mark the control as touched
            if ((this.form.get('month').touched && this.form.get('year').touched)) {
                this._onTouched();
            }
        }
        if (this.ngControl != null) {
            // triggers validation
            this.updateErrorState();
        }
    };
    ExpiryDateInputComponent.prototype.notifyChanged = function (value) {
        this.stateChanges.next();
        this._onChange(value);
        if (this.isExpiryEntryComplete()) {
            this._onTouched();
        }
    };
    //#region ControlValueAccessor
    ExpiryDateInputComponent.prototype.writeValue = function (value) {
        if (value != null) {
            this.form.patchValue({
                month: value.month.toString().padStart(2, '0'),
                year: value.year,
            }, { emitEvent: false });
        }
        else {
            this.form.reset({}, { emitEvent: false });
        }
    };
    ExpiryDateInputComponent.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    ExpiryDateInputComponent.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    ExpiryDateInputComponent.prototype.setDisabledState = function (isDisabled) {
        isDisabled ? this.form.disable() : this.form.enable();
    };
    //#endregion
    //#region Validator
    ExpiryDateInputComponent.prototype.validate = function (control) {
        var validationErrors = this.form.valid ? null : getErrors(this.form);
        return validationErrors;
    };
    ExpiryDateInputComponent.prototype.registerOnValidatorChange = function (fn) { };
    //#endregion
    // This doesn't seem to be used...
    ExpiryDateInputComponent.prototype.isError = function (value) {
        if (isNullOrEmpty(value.month) && isNullOrEmpty(value.year)) {
            return this.required;
        }
        if (!/[0-9]{1,2}/.test(value.month))
            return true;
        if (!/[0-9]{2}/.test(value.year))
            return true;
        return false;
    };
    Object.defineProperty(ExpiryDateInputComponent.prototype, "empty", {
        get: function () {
            return !this.form.value || (isNullOrEmpty(this.form.value.month) && isNullOrEmpty(this.form.value.year));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExpiryDateInputComponent.prototype, "value", {
        get: function () {
            var _a = this.form.value, month = _a.month, year = _a.year;
            if (!isNullOrEmpty(month) && !isNullOrEmpty(year)) {
                return new ExpiryDate(month, year);
            }
            return null;
        },
        set: function (value) {
            var _a = value || new ExpiryDate(null, null), month = _a.month, year = _a.year;
            this.form.setValue({ month: month, year: year });
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExpiryDateInputComponent.prototype, "disabled", {
        get: function () { return this._disabled; },
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
            this._disabled ? this.form.disable() : this.form.enable();
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExpiryDateInputComponent.prototype, "placeholder", {
        get: function () {
            return this._placeholder;
        },
        set: function (plh) {
            this._placeholder = plh;
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExpiryDateInputComponent.prototype, "required", {
        get: function () {
            return this._required;
        },
        set: function (req) {
            this._required = coerceBooleanProperty(req);
            this.stateChanges.next();
        },
        enumerable: true,
        configurable: true
    });
    ExpiryDateInputComponent.prototype.setValue = function () {
        this.stateChanges.next();
    };
    ExpiryDateInputComponent.prototype.setDescribedByIds = function (ids) {
        this.describedBy = ids.join(' ');
    };
    ExpiryDateInputComponent.prototype.onContainerClick = function (event) {
        if (event.target.tagName.toLowerCase() !== 'input') {
            this.elRef.nativeElement.querySelector('input').focus();
        }
    };
    Object.defineProperty(ExpiryDateInputComponent.prototype, "shouldLabelFloat", {
        get: function () {
            return this.focused || !this.empty;
        },
        enumerable: true,
        configurable: true
    });
    ExpiryDateInputComponent.prototype.isExpiryEntryComplete = function () {
        return (this.form.get('month').touched || this.form.get('month').value)
            && (this.form.get('year').touched || this.form.get('year').value);
    };
    ExpiryDateInputComponent.nextId = 0;
    return ExpiryDateInputComponent;
}(_AwpComponentMixinBase));
export { ExpiryDateInputComponent };
